import React, { useState } from "react";
import "./FAQAccordion.css";

// Uniamo i due array alternandoli per il nuovo sistema a griglia (riga per riga)
const faqs = [
  {
    question: "Chi può diventare un partner di Psicopatici?",
    answer: `Chiunque abbia una community, un pubblico o un'attività online può diventare Partner. Se sei un content creator, un influencer, un marketer o gestisci un blog o e-commerce, sei perfettamente adatto al nostro programma.`
  },
  {
    question: "Quali azioni generano guadagni?",
    answer: `Tutti gli acquisti effettuati tramite il link di tracciamento di un partner oppure gli acquisti effettuati inserendo il codice di riferimento del partner.`
  },
  {
    question: "Devo già essere cliente Psicopatici?",
    answer: `No, non è necessario. Ma se conosci il brand e ne condividi lo stile, sarà ancora più facile promuoverlo in modo autentico ed efficace.`
  },
  {
    question: "Come monitoro il mio lavoro e come ricevo il pagamento?",
    answer: `Ogni partner ha a disposizione una dashboard personale dove poter monitorare in tempo reale l’andamento delle proprie vendite, report personalizzati e tutte le informazioni relative alla propria rete. Il pagamento avviene ogni 3 mesi, tramite bonifico bancario, a saldo fattura emessa dal partner di riferimento e caricata all’interno della sua Area Partner.`
  },
  {
    question: "Quali metodi di promozione sono accettati?",
    answer: `Social media, blog, newsletter, video, passaparola, QR code in negozio, live streaming e molto altro. L’importante è rispettare le nostre linee guida etiche.`
  },
  {
    question: "Dove trovo i materiali per promuovere?",
    answer: `Una volta approvato, avrai accesso all'area partner con grafiche, banner, codici sconto personalizzati e consigli su come promuovere al meglio Psicopatici.`
  }
];

function FAQAccordion() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFaq = (index) => {
    // Chiude l'accordion se ci clicchi di nuovo, altrimenti apre quello selezionato
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="container py-5">
      <div className="faq-grid">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item-card">

            <div className="faq-header" onClick={() => toggleFaq(index)}>
              <span className="text-black fw-bold" style={{ fontSize: "16px", paddingRight: "15px" }}>
                {faq.question}
              </span>
              <span className="faq-symbol">
                {activeIndex === index ? "–" : "+"}
              </span>
            </div>

            {/* Il wrapper animato per l'altezza */}
            <div className={`faq-body ${activeIndex === index ? "open" : ""}`}>
              <div className="faq-body-content">
                {faq.answer}
              </div>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQAccordion;